<template>
	<div id="app">
		<router-view v-wechat-title="$route.meta.title" />
<!--    <keep-alive >-->
<!--      <router-view v-if="$route.meta.keepAlive" v-wechat-title="$route.meta.title"></router-view>-->
<!--    </keep-alive>-->
<!--    <router-view v-if="!$route.meta.keepAlive" v-wechat-title="$route.meta.title"></router-view>-->
	</div>
</template>

<script>
export default {
	name: 'App',
	provide() {
		return {
			reload: this.reload
		}
	},
	data() {
		return {
			isRouterAlive: true,
		}
	},
	methods: {
		reload() {
			this.isRouterAlive = false;
			this.$nextTick(function () {
				this.isRouterAlive = true
			});
		}
	}
}

</script>
<style lang="stylus">
  html, body {
    height 100%
  }
  body
    margin: 0
    padding: 0
	#app
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* text-align: center; */
    height 100%
    width BodyMaxWidth
    min-width BodyMaxWidth
    @media screen and (min-width: BodyMaxWidth)
      width auto
	.ul1 {
		/* margin-top: 0; */
		/* margin-bottom: 0; */
		/* width: 50%; */
		list-style: none;
		height: 90px;
		display: inline-block;
		line-height: 90px;
		padding: 0;
		margin: 0;
	}

	.ul1 li {
		display: inline-block;
		/* width: 10%; */
		font-size: 15px;
		height: 90px;
		line-height: 90px;
	}

  p {
    margin: 0;
  }

	.div3 p {
		line-height: 20px;
	}

	.is-active {
		color: #1264ff;
	}

	.not-active {
		color: black;
	}

	a {
		text-decoration: none;
	}

	.item {
		margin-top: 10px;
		margin-right: 40px;
	}

	#app table{
		border-color: #abadb3;
		/* border-collapse: collapse; */
	}
	#app .el-table--border{
		//  border: 1px solid #abadb3;
		 /* border-left: none; */
	}

</style>
